<template>
  <q-layout>
    <div class="page-header">
      <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('schedule_payments') }}</q-toolbar-title>
      <q-breadcrumbs class="q-mr-auto q-ma-sm">
        <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
        <q-breadcrumbs-el :label="$t('schedule_payments')" exact />
      </q-breadcrumbs>
    </div>
    <q-page padding>
      <header-schedule-payments />
      <list-schedule-payments />
    </q-page>
  </q-layout>
</template>

<script>
import HeaderSchedulePayments from '../../components/financial/HeaderSchedulePayments.vue';
import ListSchedulePayments from '../../components/financial/ListSchedulePayments.vue';

export default {
  name: 'SchedulePayments',
  components: {
    HeaderSchedulePayments,
    ListSchedulePayments
  }
};
</script>
